import ClickAwayListener from '@components/App/ClickAwayListener/ClickAwayListener'
import { Button } from '@octopus-do/octopus-storybook'
import cx from 'classnames'
import React from 'react'

import css from './InputWithButton.module.scss'

// @ts-expect-error
// biome-ignore lint/suspicious/noShadowRestrictedNames: Error is a domain component name
const Error: React.FC = ({ children }) => (
  <div className="invite-error">{children}</div>
)

type ClassNames = {
  container?: string
  input?: string
  button?: string
}

type Props = {
  buttonContent: string
  hideButton?: boolean
  onSubmit: () => void
  onClickAway?: () => void
  error?: boolean
  errorText?: string
  isLoading?: boolean
  inputTestId?: string
  buttonTestId?: string
  classNames?: ClassNames
}

type InputType = Omit<
  React.HTMLProps<HTMLInputElement>,
  'size' | 'type' | 'onKeyDown' | 'onSubmit'
>

const InputWithButton: React.ForwardRefRenderFunction<
  HTMLInputElement,
  Props & InputType
> = (
  {
    buttonContent,
    hideButton,
    onSubmit,
    onClickAway,
    error,
    errorText,
    isLoading,
    inputTestId,
    buttonTestId,
    className,
    classNames,
    ...inputProps
  },
  ref
) => {
  const onKeyDown = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault()
      onSubmit()
    }
  }

  const containerClassName = cx(css.wrapper, classNames?.container)
  const inputClassName = cx(css.input, classNames?.input, {
    [css.error]: !!error,
  })
  const buttonClassName = cx(css.button, classNames?.button)

  // biome-ignore lint/plugin/no-jsx-in-function-variables: legacy pattern
  const renderContent = () => (
    <>
      <input
        ref={ref}
        type="text"
        data-testid={inputTestId}
        onKeyDown={onKeyDown}
        className={inputClassName}
        {...inputProps}
      />
      {!hideButton && (
        <Button
          className={buttonClassName}
          size="small"
          label={buttonContent}
          loading={isLoading}
          disabled={!!errorText}
          data-testid={buttonTestId}
          onClick={onSubmit}
        />
      )}
    </>
  )

  return (
    <>
      {onClickAway ? (
        <ClickAwayListener
          className={containerClassName}
          onClickAway={onClickAway}
        >
          {renderContent()}
        </ClickAwayListener>
      ) : (
        <div className={containerClassName}>{renderContent()}</div>
      )}
      {/*@ts-ignore*/}
      {errorText && <Error>{errorText}</Error>}
    </>
  )
}

export default React.forwardRef(InputWithButton)
